import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "clearfix" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "line"
}
const _hoisted_6 = {
  key: 1,
  class: "lang"
}
const _hoisted_7 = { class: "clearfix" }
const _hoisted_8 = ["onClick"]

import { ref, onMounted, watch } from "vue";
import { getMenuTree } from "@/api/index";
import { useRouter, useRoute } from "vue-router";

import logo from "@/assets/website/logo.png";
import logo2 from "@/assets/website/logo2.png";
import { useI18n } from "vue-i18n";
import { fa } from "element-plus/lib/locale";

export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  props: {
  style: String,
  isMobile: Boolean,
  hasbg: Boolean,
},
  emits: ["getBanner"],
  setup(__props, { emit: __emit }) {

const { locale } = useI18n();

const router = useRouter();
const route = useRoute();
const hasbg = ref(false);
const props = __props;

const mb = ref(false);
const lng = ref("");

const drawer = ref(false);
const emit = __emit;
watch(
  () => props.isMobile,
  (newv, oldv) => {
    props.isMobile ? (mb.value = true) : (mb.value = false);
  }
);

let navs: any = ref("");

const changeLang = (v: any) => {
  locale.value = v;
  lng.value = v;
  localStorage.setItem("lng", v);
  // location.reload();
};
const getList = () => {
  getMenuTree("MENU_CLASSFIER_WEBSITE").then((res: any) => {
    for (const item of res.data) {
      if (route.path.indexOf(item.path) === 0) {
        item.checked = true;
        emit("getBanner", item.files);
      }
    }
    // console.log(99999);
    // console.log(res);

    navs.value = res.data;
  });
};

const navClick = (i: any) => {
  for (const item of navs.value) {
    item.checked = false;
    navs.value[i].checked = true;
  }
  router.push(navs.value[i].path);
  // emit('getBanner', navs.value[i].icon);
};

const scroll = (val: any) => {
  if (val.scrollTop > 100) {
    hasbg.value = true;
  } else {
    hasbg.value = false;
  }
};

onMounted(() => {
  getList();
  lng.value = locale.value;
  mb.value = props.isMobile;
});

return (_ctx: any,_cache: any) => {
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_affix = _resolveComponent("el-affix")!

  return (_openBlock(), _createBlock(_component_el_affix, {
    offset: 0,
    onScroll: scroll
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["navbar", [mb.value ? 'Mobile' : 'pc', hasbg.value ? 'navbg' : '']])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["nav clearfix", { ww: __props.style == 'ww', w: __props.style == 'w' }])
        }, [
          _createElementVNode("div", {
            class: "logo",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/home')))
          }, [
            _createElementVNode("img", {
              src: (__props.style == 'w' || __props.style == 'ww') && !hasbg.value ? _unref(logo2) : _unref(logo),
              alt: "晋才科技"
            }, null, 8, _hoisted_1)
          ]),
          (!mb.value)
            ? (_openBlock(), _createElementBlock("nav", _hoisted_2, [
                _createElementVNode("ul", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(navs), (item, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: index,
                      class: _normalizeClass({ checked: item.checked }),
                      onClick: ($event: any) => (navClick(index))
                    }, [
                      _createTextVNode(_toDisplayString(lng.value == "zh" ? item.menuName : item.englishName) + " ", 1),
                      (item.checked)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_4))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          (!mb.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6))
            : _createCommentVNode("", true),
          (mb.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "more",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (drawer.value = true))
              }, [...(_cache[3] || (_cache[3] = [
                _createElementVNode("i", { class: "iconfont icon-gengduo" }, null, -1)
              ]))]))
            : _createCommentVNode("", true)
        ], 2),
        (mb.value)
          ? (_openBlock(), _createBlock(_component_el_drawer, {
              key: 0,
              modelValue: drawer.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((drawer).value = $event)),
              withHeader: false,
              size: '50%'
            }, {
              default: _withCtx(() => [
                _createElementVNode("ul", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(navs), (item, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: index,
                      class: _normalizeClass({ checked: item.checked }),
                      onClick: ($event: any) => (navClick(index))
                    }, _toDisplayString(item.menuName), 11, _hoisted_8))
                  }), 128))
                ])
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _: 1
  }))
}
}

})